import { BroadcastUserTypeEnum, BroadcastMessageTypeEnum, BroadcastChannelTypeEnum, BroadcastReceiverTypeEnum } from 'app/models';

export class BroadcastMessageCreate {
    Id: number = 0;
    SenderUserId: number | null = null;
    BroadcastUserType: BroadcastUserTypeEnum | null = null;
    BroadcastMessageType: BroadcastMessageTypeEnum | null = null;
    BroadcastChannelType: BroadcastChannelTypeEnum | null = null;
    BroadcastStartDateTime: Date | null = null;
    BroadcastReceiverType: BroadcastReceiverTypeEnum | null = null;
    ReceiverDays: number = 0;
    MessageTitle: string | null = null;
    MessageSubTitle: string | null = null;
    MessageImageUrl: string = '';
    MessageText: string | null = null;
}
